/* Package JSON Import will be here */
import { Modal } from 'antd';
/* Package JSON Import will be here */

/* Const,Let & Var will be here */
const { confirm } = Modal;
/* Const,Let & Var will be here */

const modalConfirmationHook = (title, translate, onSuccessCallBack: any, okText = "", cancelText = "") => {
    return (
        /* Generate complaint confirmation modal */
        confirm({
            title: title,
            centered: true,
            okText: okText === "" ? translate("common.buttons.ok") : okText,
            cancelText: cancelText === "" ? translate("common.buttons.cancel") : cancelText,
            maskClosable: false,
            okButtonProps: { size: "large", shape: "circle", style: { width: "100px" }},
            cancelButtonProps: { size: "large", shape: "circle", style: { width: "100px" }},
            onOk: () => {
                onSuccessCallBack()
            }
        })
    );
};

export default modalConfirmationHook;